export const appearanceModifierErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (categoryid !== undefined && desyncdata !== undefined) {
		if (categoryid.indexOf('appearance_modifier') !== -1 && desyncdata.indexOf('TypeError: Failed to parse argument') !== -1) {
			return {
				type: 'appearanceModifierErrorTest',
				color: 'IndianRed',
				title: 'Appearance Modifier Error',
				text: 'Outdated mod uses appearance modifiers.',
				description: 'An outdated modification adds new moodlets (buffs) that modify Sims visual appearance.<br/><br/>' +
        'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that could be causing this issue and remove it. Try starting with the oldest modifications you have.<br/>' +
        'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>479c4845fc16c9e65b68d843</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-08-06 18:25:18</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.62.1020-1.200.000.360.Release</buildsignature>
        <categoryid>appearance_modifier.py:226</categoryid>
        <desyncid>479c4845fc16c9e65b68d843</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception in Sim Timeline: Exception resuming Element (TypeError: Failed to parse argument.)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 217, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 385, in _resume
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 2551, in _startup_sim_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity_tracker.py&quot;, line 115, in start_regular_simulation
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity_tracker.py&quot;, line 85, in on_initial_startup
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py&quot;, line 925, in on_initial_startup
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py&quot;, line 858, in _setup_commodity_states
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py&quot;, line 1251, in _set_state
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py&quot;, line 1197, in _add_buff_from_state
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\__init__.py&quot;, line 460, in exported_func
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\buff_component.py&quot;, line 304, in add_buff
  File &quot;T:\InGame\Gameplay\Scripts\Server\buffs\buff.py&quot;, line 996, in on_add
  File &quot;T:\InGame\Gameplay\Scripts\Server\buffs\appearance_modifier\appearance_tracker.py&quot;, line 96, in add_appearance_modifiers
  File &quot;T:\InGame\Gameplay\Scripts\Server\buffs\appearance_modifier\appearance_tracker.py&quot;, line 159, in evaluate_appearance_modifiers
  File &quot;T:\InGame\Gameplay\Scripts\Server\buffs\appearance_modifier\appearance_modifier.py&quot;, line 226, in combinable_sorting_key
TypeError: Failed to parse argument.
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/appearanceModifierErrorTest.js